import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  VERIFY_EMAIL_ACCOUNT,
  VERIFY_EMAIL_ACCOUNT_SUCCESS,
  VERIFY_EMAIL_ACCOUNT_ERROR,
  POST_RESET_USER,
  POST_RESET_USER_SUCCESS,
  POST_RESET_USER_FAIL,
  POST_CHANGE_PASSWORD,
  POST_CHANGE_PASSWORD_SUCCESS,
  POST_CHANGE_PASSWORD_FAIL,
} from "./actionTypes"

export const userForgetPassword = (user) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}
//reset password
export const userResetPassword = (user, navigate) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, navigate },
  }
}

export const userResetPasswordSuccess = message => {
  
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: message,
  }
}
export const userResetPasswordError = message => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: message,
  }
}
export const EmailVerify = (user) => {
  return {
    type: VERIFY_EMAIL_ACCOUNT,
    payload: { data:user },
  }
}
export const EmailVerifySuccess = message => {
  return {
    type: VERIFY_EMAIL_ACCOUNT_SUCCESS,
    payload: message,
  }
}
export const EmailVerifyError = message => {
  return {
    type: VERIFY_EMAIL_ACCOUNT_ERROR,
    payload: message,
  }
}

//reset password
export const resetUser = (user, history) => ({
  type: POST_RESET_USER,
  payload: { user, history },
})

export const resetUserSuccesss = message => ({
  type: POST_RESET_USER_SUCCESS,
  payload: message,
})

export const resetUserFails = message => ({
  type: POST_RESET_USER_FAIL,
  payload: message,
})

//change password
export const changepwd = (data, callback) => ({
  type: POST_CHANGE_PASSWORD,
  payload: data,
  callback
})

export const changepwdSuccess = message => ({
  type: POST_CHANGE_PASSWORD_SUCCESS,
  payload: message,
})

export const changepwdFails = message => ({
  type: POST_CHANGE_PASSWORD_FAIL,
  payload: message,
})
